import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => api.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false)));
  }, []);
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email: email.trim(), password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("ih_builder");
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const can = (user, ...perms) => !!user && perms.some((p) => user.perms?.includes(p));

export function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (["3dvista", "giraffe"].includes(user.product)) return <SwitchAccount />;
  return children;
}

function SwitchAccount() {
  const { user, logout } = useAuth();
  const out = async () => { await logout(); window.location.href = "/admin/login"; };
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6" data-testid="admin-switch-account">
      <div className="max-w-md rounded-3xl bg-white border p-8 text-center">
        <p className="font-serif text-2xl">You're signed in with your {user.product === "giraffe" ? "Giraffe360" : "3DVista"} account</p>
        <p className="text-sm text-slate-500 mt-2">{user.email} can't open the admin. Sign out, then log in with your admin email to see the dashboards.</p>
        <div className="mt-6 flex flex-col gap-2">
          <button onClick={out} className="h-11 rounded-full bg-[#0F2A47] text-white font-semibold" data-testid="admin-switch-signout">Sign out and log in as admin</button>
          <a href={user.product === "giraffe" ? "/giraffe/app" : "/3dvista/app"} className="h-11 grid place-items-center rounded-full border font-semibold" data-testid="admin-switch-tdv">Go to my tours</a>
        </div>
      </div>
    </div>
  );
}
